<template>
  <div class="content main-container">
    <div class="tips">
      <img src="@/static/images/contentManage/tips.png" alt="">
      <div class="tipsContent">
        <span class="tips1">本模块支持您自己创建朋友圈助手的发布素材，也支持您从公共素材库导入。</span>
        <div class="tips2">
          <i class="iconfont iconzhuyi1"></i>
          <span>本功能需配套使用APP端
            <span style="color: #FF0000;">新版</span>【<img src="@/static/images/contentManage/new2.png" alt="">展业素材】或
            <span style="color: #FF0000;">新版</span>【<img src="@/static/images/contentManage/new1.png" alt="">朋友圈】，如果您有此类自定义的需求，请在展业端配置-模块配置里将对应
            <span style="color: #FF0000;">旧版</span>【朋友圈助手】删除，添加
            <span style="color: #FF0000;">新版</span>
            系统工具：【<img src="@/static/images/contentManage/new2.png" alt="">展业素材】</span>或
            <span style="color: #FF0000;">新版</span>【<img src="@/static/images/contentManage/new1.png" alt="">
            朋友圈】
        </div>
      </div>
    </div>
    <div class="search-box">
      <div class="input-item">
        <span class="label">文案关键词</span>
        <Input v-model="searchParams.copywriting" placeholder="请输入文案关键词" clearable />
      </div>
      <div class="input-item">
        <span class="label">引用类型</span>
        <Select v-model="searchParams.type" transfer placeholder="请选择引用类型" clearable>
          <Option value="6">图片</Option>
          <Option value="7">视频</Option>
          <Option value="8">文章</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">所属栏目</span>
        <selectTreeOld :data="columnList" :multiple="true" :size="null" placeholder="请选择" :single="true"
          :showParentNode="true" :selectAllChildren="false" v-model="searchParams.columnIdList" @check="checkList">
        </selectTreeOld>
      </div>
      <div class="input-item">
        <span class="label">关联产品</span>
        <Select :label-in-value="true" v-model="searchParams.productCodeList" placeholder="请选择" filterable clearable
          multiple>
          <Option :value="product.productCode" v-for="product in productListArr" :key="product.id">{{
            product.productName }}</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">来源</span>
        <RadioGroup v-model="searchParams.source" @on-change="getList()">
          <Radio label="">全部</Radio>
          <Radio label="0">素材库</Radio>
          <Radio label="1">自建</Radio>
        </RadioGroup>
      </div>
      <div class="input-item">
        <span class="label">发布状态</span>
        <Select v-model="searchParams.isPublish" transfer placeholder="请选择" clearable>
          <Option value="0">未发布</Option>
          <Option value="1">已发布</Option>
        </Select>
      </div>
      <div class="input-item">
        <span class="label">展示机构</span>
        <selectTree type="4" status="1" v-model="searchParams.orgId"></selectTree>
      </div>
      <div class="input-item">
        <span class="label">发布时间</span>
        <DatePicker type="daterange" split-panels separator="至" :transfer="true" placement="bottom" format="yyyy-MM-dd"
          placeholder="选择日期" :value="searchParams.date" @on-change="searchParams.date = $event"></DatePicker>
      </div>
      <div class="btn-item">
        <Button type="primary" @click="getList()">查询</Button>
        <Button type="primary" ghost @click="resetSearch(), searchParams.date = []">重置</Button>
      </div>
    </div>
    <div class="buttonBox">
      <Button type="primary" @click="openModal()" v-if="$units.pointAction('content_3_1_1')">+新增</Button>
      <Button type="warning" @click="toPublicMaterialsPage" v-if="$units.pointAction('content_3_1_5')">从公共素材库导入</Button>
      <Button type="primary" @click="$router.push(
        '/contentManagement/UserManagement/user'
      )" v-if="$units.pointAction('content_3_1_4')">发布用户管理</Button>
    </div>
    <div class="tableBox">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="columnName">
          <div v-for="(item, i) in row.columnName" :key="i">
            <span>{{ item }}</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="linkContent">
          <div v-if="row.type == 6" class="linkBox">
            <div :class="{ imgOne: row.linkContent.length == '1', imgBox: row.linkContent.length > '1' }">
              <div v-for="(item, i) in row.linkContent" :key="i" class="img">
                <img :src="item" :preview="row.id" :ref="'preview'+row.id">
              </div>
              <div class="clickimg" @click="clickimg(row)"></div>
            </div>
          </div>
          <div v-if="row.type == 7" class="linkBox">
            <div v-for="(item, i) in row.linkContent" :key="i">
              <video v-if="row.linkContent.length > 0" controls :src="item"
                :poster="row.videoCover ? row.videoCover : ''"></video>
            </div>
          </div>
          <div v-if="row.type == 8" class="linkBox">
            <span class="articleUrl" @click="articleUrl(row)">{{ row.article.title }}</span>
          </div>
        </template>
        <template slot-scope="{ row }" slot="tags">
          <div v-if="row.tags && row.tags.length > 0">
            <Tag v-for="(item, index) in row.tags" :key="index" color="primary">{{ item }}</Tag>            
          </div>
          <div v-else>-</div>
        </template>
        <template slot-scope="{ row }" slot="isPublish">
          <div @click="editDeail(row)">
            <i-switch v-model="row.isPublish" true-value="1" false-value="0">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </div>
        </template>
        <template slot-scope="{ row }" slot="collectionShare">
          <span>{{ row.collectTimes+'/'+row.shareTimes }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div>
            <span class="table-btn" @click="getDetail(row.id)">预览</span>
            <span class="table-btn" @click="openModal(row)" v-if="$units.pointAction('content_3_1_2')">编辑</span>
            <span class="table-btn" @click="deleteRow(row)" v-if="$units.pointAction('content_3_1_3')">删除</span>
          </div>
        </template>
      </Table>
      <Page :total="total" :current="pageNo" :page-size="pageSize" show-total @on-change="pageChange"
        style="text-align: center;margin-top:20px;" />
    </div>
    <newContentModal ref="newContentModal" @getList="getList()"></newContentModal>
    <previewModal ref="previewModal" :articleList="articleList"></previewModal>
  </div>
</template>

<script>
import newContentModal from './components/newContentModal.vue'
import selectTreeOld from '@/components/commons/selectTree';
import selectTree from "@/components/system/selectTree3";
import { pageTool } from "@/api/mixins";
import previewModal from './components/previewModal'
export default {
  components: { newContentModal, previewModal, selectTreeOld, selectTree },
  mixins: [pageTool],
  data() {
    return {
      searchParams: {
        source: '',
      },
      columnList: [],
      listLoading: false,
      productList: [],
      productListArr: [],
      articleList: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      columns: [
        {
          title: "文案",
          align: "center",
          key: "copywriting",
          minWidth: 200,
        },
        {
          title: "引用内容",
          align: "center",
          slot: "linkContent",
          minWidth: 250,
          tooltip: true,
        },
        {
          title: "标签",
          align: "center",
          slot: "tags",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "所属栏目",
          align: "center",
          slot: "columnName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "发布用户",
          align: "center",
          key: "userName",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "来源",
          align: "center",
          key: "sourceName",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "发布状态",
          align: "center",
          slot: "isPublish",
          minWidth: 100,
          tooltip: true,
        },
        {
          title: "内部收藏/分享数",
          align: "center",
          slot: "collectionShare",
          minWidth: 160,
          tooltip: true,
        },
        {
          title: "最后更新人",
          align: "center",
          key: "updateName",
          minWidth: 140,
          tooltip: true,
        },
        {
          title: "发布时间",
          align: "center",
          key: "publishTime",
          minWidth: 200,
          tooltip: true,
        },
        {
          title: "操作",
          slot: "action",
          align: 'center',
          width: 180,
          fixed: 'right'
        }
      ],
    }
  },
  created() {
    this.initListAjax("/buz/friendsCircle/read/list");
    this.getProductList();
    this.getColumnList();
  },
  activated(){
    this.getList();    
  },
  methods: {
    clickimg(row){
      
      this.$refs['preview'+row.id][0].click()
    },
    editDeail(item) {
      this.$http({
        url: '/buz/friendsCircle/updatePublishStatus',
        type: "POST",
        data: {
          id: item.id,
          isUse: item.isPublish
        }
      }).then(res => {
        this.getList()
      })
    },
    listCallback() {
      setTimeout(() => {
        const father = document.getElementsByClassName('ivu-table-fixed-right')
        for (let i = 0; i < father.length; i++) {
          let p = father[i].getElementsByTagName('img')
          for (let index = 0; index < p.length; index++) {
            p[index].removeAttribute('preview')
          }
        }
        this.$previewRefresh();
      }, 1000)

    },
    checkList(item) {
      this.searchParams.columnIdList = item[1]
      JSON.parse(JSON.stringify(this.searchParams.columnIdList))
    },
    setListParams(params) {
      if (this.searchParams.date && this.searchParams.date.length > 0) {
        params.beginPublishTime = this.searchParams.date[0]
        params.endPublishTime = this.searchParams.date[1]
      }
    },
    getDetail(id) {
      this.$http({
        url: '/buz/friendsCircle/read/detail',
        type: "GET",
        data: {
          id: id,
        }
      }).then(res => {
        this.$refs.previewModal.open(res.data)
        if (res.data.article) {
          this.articleList = [res.data.article]
        }
      })
    },
    deleteRow(row) {
      this.$notice.inquiry('确认删除操作？').then(async () => {
        this.$http({
          url: `/buz/friendsCircle/del`,
          type: "GET",
          data: {
            id: row.id
          }
        }).then((res) => {
          this.$Message.success("删除成功");
          this.getList();
        })
      })
    },
    pageChange(pageNo) {
      this.pageNo = pageNo
      this.getList(pageNo)
    },
    articleUrl(row) {
      window.open(row.article.url, "_blank")
    },
    openModal(item) {
      this.$refs.newContentModal.open(item)
    },
    // 从公共素材库导入
    toPublicMaterialsPage() {
      this.$router.push({
        path: '/contentManagement/publicMaterialLibrary',
        query: {
          typeIndex: 2,
          time:JSON.stringify(new Date())
        }
      })
    },
    // 产品
    getProductList() {
      this.$http({
        url: "/buz/productBase/read/short/list",
        type: "post",
        data: {
          pageNo: 1,
          pageSize: 9999,
        },
      }).then((res) => {
        this.productListArr = res.data;
      }).catch((err) => {
        console.log(err)
      });
    },
    getColumnList() {
      this.$http({
        url: '/buz/cmsColumn/read/list',
        type: "POST",
        data: {
          type: 3,
        }
      }).then(res => {
        this.columnList = this.dealTree(res.data);
      })
    },
    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        value: item.id,
        label: item.name,
        title: item.name,
        expand: true,
        children: item.children && item.children.length > 0 ? this.dealTree(item.children, item.name) : null
      }));
    },
  }
}
</script>

<style lang="scss" scoped>@import './index.scss';</style>